(() => {
 if (customElements.get('top-delivery')) return;
 const rootURL=()=>window.Shopify?.routes?.root||'/';
 const key=d=>d.toISOString().slice(0,10);
 function dates(now,cutoff,closed,transit,end){
  const parts=Object.fromEntries(new Intl.DateTimeFormat('en-GB',{timeZone:'Europe/Madrid',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',hourCycle:'h23'}).formatToParts(now).map(p=>[p.type,p.value]));
  let d=new Date(`${parts.year}-${parts.month}-${parts.day}T12:00:00Z`);
  const business=(x,set)=>x.getUTCDay()!==0&&x.getUTCDay()!==6&&!set.has(key(x));
  const add=(x,n,set)=>{x=new Date(x);for(let i=0;n&&i<370;i++){x.setUTCDate(x.getUTCDate()+1);if(business(x,set))n--;}return x;};
  if(Number(parts.hour)>=cutoff||!business(d,closed))d=add(d,1,closed);
  const first=add(d,1,transit),last=add(d,3,transit);
  if(!end||key(last)>end)return null;
  return {dispatch:d,first,last};
 }
 class TopDelivery extends HTMLElement {
  connectedCallback(){
   if(this.started)return;this.started=true;this.version=0;
   this.text=JSON.parse(this.querySelector('[data-delivery-text]').textContent);
   this.abort=new AbortController();const signal=this.abort.signal;
   this.closed=new Set((this.dataset.closed||'').split(',').map(x=>x.trim()));
   this.transit=new Set((this.dataset.transitClosed||'').split(',').map(x=>x.trim()));
   if(this.dataset.context==='product'){this.renderDates();document.addEventListener('visibilitychange',()=>this.renderDates(),{signal});return;}
   this.country=this.querySelector('[data-country]');this.province=this.querySelector('[data-province]');this.zip=this.querySelector('[data-zip]');this.button=this.querySelector('[data-calculate]');this.result=this.querySelector('[data-result]');this.status=this.querySelector('[data-status]');this.rate=this.querySelector('[data-rate]');
   this.country.addEventListener('change',()=>{this.provinces();this.destinationChanged();},{signal});
   this.province.addEventListener('change',()=>this.destinationChanged(),{signal});this.zip?.addEventListener('input',()=>this.invalidate(),{signal});
   this.zip?.addEventListener('keydown',e=>{if(e.key==='Enter'){e.preventDefault();this.calculate();}},{signal});
   this.button?.addEventListener('click',()=>this.calculate(),{signal});this.rate?.addEventListener('change',()=>this.renderTotal(),{signal});
   ['cart:updated','ajaxProduct:added'].forEach(name=>document.addEventListener(name,()=>{this.invalidate(this.text.stale);this.refreshCart();},{signal}));
   document.addEventListener('visibilitychange',()=>{if(!document.hidden){this.invalidate(this.text.stale);this.refreshCart();}},{signal});
   this.shippingText=JSON.parse(this.querySelector('[data-shipping-text]').textContent);
   this.form=this.closest('form');
   this.progress=this.querySelector('[data-progress]');
   this.progressButton=this.querySelector('[data-progress-complements]');
   this.progressButton.addEventListener('click',()=>{
    const target=this.form?.querySelector('top-cart-treatment h2');
    if(target){target.setAttribute('tabindex','-1');target.focus({preventScroll:true});target.scrollIntoView({block:'center',behavior:'auto'});}
   },{signal});
   this.observer=new MutationObserver(()=>this.readCartState());
   const products=this.form?.querySelector('[data-products]');
   if(products)this.observer.observe(products,{childList:true,subtree:true});
   document.addEventListener('top:shipping-destination',event=>{
    if(event.detail.source===this)return;
    this.restoreDestination(event.detail);this.invalidate();this.renderProgress();
   },{signal});
   try{const saved=JSON.parse(sessionStorage.getItem('top-shipping-destination')||'null');if(saved)this.restoreDestination(saved);}catch{}
   this.readCartState();
  }
  disconnectedCallback(){this.observer?.disconnect();this.cartRequest?.abort();this.abort?.abort();this.request?.abort();this.version++;this.started=false;}
  provinces(){
   let list=[];try{list=JSON.parse(this.country.selectedOptions[0].dataset.provinces||'[]');}catch{}
   this.province.replaceChildren(new Option('—',''),...list.map(([value,label])=>new Option(label,value)));
   this.querySelector('[data-province-label]').hidden=!list.length;
  }

  restoreDestination(saved){
   this.country.value=saved.country||'';this.provinces();
   this.province.value=saved.province||'';
  }
  destinationChanged(){
   this.invalidate();
   const destination={country:this.country.value,province:this.province.value};
   try{sessionStorage.setItem('top-shipping-destination',JSON.stringify(destination));}catch{}
   document.dispatchEvent(new CustomEvent('top:shipping-destination',{detail:{...destination,source:this}}));
   this.renderProgress();
  }
  readCartState(){
   const node=this.form?.querySelector('[data-shipping-cart]');
   if(!node||node.textContent===this.stateText)return;
   this.cartRequest?.abort();
   this.stateText=node.textContent;
   try{this.shippingCart=JSON.parse(this.stateText);this.renderProgress();}catch{this.progress.hidden=true;}
  }
  async refreshCart(){
   if(!this.shippingText)return;
   this.cartRequest?.abort();
   const request=new AbortController();this.cartRequest=request;
   this.querySelector('[data-progress-bar]').hidden=true;
   this.querySelector('[data-progress-amount]').hidden=true;
   this.progressButton.hidden=true;
   this.querySelector('[data-progress-message]').textContent=this.shippingText.refresh;
   try{
    const response=await fetch(rootURL()+'cart.js',{cache:'no-store',signal:request.signal});
    if(!response.ok)throw Error('cart');
    const cart=await response.json();if(request.signal.aborted)return;
    this.shippingCart={total:cart.total_price,currency:cart.currency,requiresShipping:cart.requires_shipping,count:cart.item_count};
    this.renderProgress();
   }catch{if(!request.signal.aborted)this.querySelector('[data-progress-message]').textContent=this.shippingText.unavailable;}
  }
  shippingTarget(){
   const country=this.country.value,province=this.province.value;
   if(!country)return 7000;
   if(['Spain','Portugal'].includes(country)&&!province)return undefined;
   if(country==='Spain')return ['Balears','Islas Baleares','Las Palmas','Santa Cruz de Tenerife','Ceuta','Melilla'].includes(province)?10000:7000;
   if(country==='Portugal')return 7000;
   return ['Andorra','Austria','Belgium','Bulgaria','Czech Republic','Denmark','France','Germany','Hungary','Italy','Lithuania','Romania','Sweden','Netherlands'].includes(country)?10000:null;
  }
  renderProgress(){
   if(!this.progress||!this.shippingCart)return;
   const cart=this.shippingCart;
   const defaultDestination=this.querySelector('[data-default-destination]');
   if(defaultDestination)defaultDestination.hidden=!!this.country.value||!cart.requiresShipping;
   this.progress.hidden=!cart.count;
   const message=this.querySelector('[data-progress-message]'),bar=this.querySelector('[data-progress-bar]'),amount=this.querySelector('[data-progress-amount]');
   bar.hidden=true;amount.hidden=true;this.progressButton.hidden=true;this.progress.dataset.reached='false';
   if(!cart.requiresShipping){message.textContent=this.shippingText.digital;return;}
   const target=this.shippingTarget();
   if(target===undefined){message.textContent=this.shippingText.choose;return;}
   if(!target||cart.currency!=='EUR'){message.textContent=this.shippingText.unsupported;return;}
   const total=Math.max(0,Number(cart.total));
   if(!Number.isFinite(total)){message.textContent=this.shippingText.unavailable;return;}
   const remaining=Math.max(0,target-total);
   const money=n=>new Intl.NumberFormat(document.documentElement.lang||'es',{style:'currency',currency:cart.currency}).format(n/100);
   message.textContent=remaining?this.shippingText.remaining.replace('{amount}',money(remaining)):this.shippingText.reached;
   bar.max=target;bar.value=Math.min(total,target);bar.hidden=false;
   amount.textContent=this.shippingText.amount.replace('{amount}',money(total)).replace('{target}',money(target));amount.hidden=false;
   this.progress.dataset.reached=String(!remaining);
   this.progressButton.hidden=!remaining||!this.form?.querySelector('top-cart-treatment [data-treatment-card]');
  }

  invalidate(message=''){this.version++;this.request?.abort();if(this.result)this.result.hidden=true;if(this.status)this.status.textContent=message;if(this.button)this.button.disabled=false;}
  renderDates(){
   const el=this.querySelector('[data-dates]');if(!el)return;el.textContent='';
   const range=dates(new Date(),Number(this.dataset.cutoff),this.closed,this.transit,this.dataset.calendarEnd);
   if(!range)return;
   const format=d=>new Intl.DateTimeFormat(document.documentElement.lang||'es',{day:'numeric',month:'short',timeZone:'UTC'}).format(d);
   el.textContent=this.text.dispatch.replace('{date}',format(range.dispatch))+' '+this.text.arrival.replace('{from}',format(range.first)).replace('{to}',format(range.last));
  }
  async calculate(){
   this.invalidate();if(!this.country.value||!this.zip.value.trim()){this.status.textContent=this.text.required;return;}
   const version=this.version;const controller=new AbortController();this.request=controller;const signal=controller.signal;
   const timeout=setTimeout(()=>controller.abort(),20000);
   this.button.disabled=true;this.status.textContent=this.text.working;
   const get=async(url,options={})=>{const response=await fetch(rootURL()+url,{...options,signal});if(!response.ok)throw Error('request');return response.json();};
   try{
    const cart=await get('cart.js');if(!cart.item_count){this.status.textContent=this.text.empty;return;}
    if(!cart.requires_shipping){this.status.textContent=this.text.digital;return;}
    const params=new URLSearchParams({'shipping_address[country]':this.country.value,'shipping_address[zip]':this.zip.value.trim(),'shipping_address[province]':this.province.value});
    await get('cart/prepare_shipping_rates.json?'+params,{method:'POST'});
    let data=null;
    for(let i=0;i<10;i++){if(signal.aborted)throw Error('aborted');data=await get('cart/async_shipping_rates.json?'+params);if(data)break;await new Promise(resolve=>setTimeout(resolve,700));}
    if(!data)throw Error('timeout');
    const updated=await get('cart.js');
    if(version!==this.version)return;
    if(JSON.stringify(updated.items)!==JSON.stringify(cart.items)||updated.total_price!==cart.total_price){this.status.textContent=this.text.changed;return;}
    this.rates=(data.shipping_rates||[]).filter(r=>Number.isFinite(Number(r.price))&&Number(r.price)>=0);
    if(!this.rates.length){this.status.textContent=this.text.none;return;}
    this.cart=updated;this.money=n=>new Intl.NumberFormat(document.documentElement.lang||'es',{style:'currency',currency:updated.currency}).format(n/100);
    this.rate.replaceChildren(...this.rates.map((r,i)=>new Option(`${r.presentment_name||r.name} · ${this.money(Math.round(Number(r.price)*100))}`,String(i))));
    this.status.textContent='';this.result.hidden=false;this.renderTotal();
   }catch{if(version===this.version)this.status.textContent=this.text.error;}
   finally{clearTimeout(timeout);if(version===this.version)this.button.disabled=false;}
  }
  renderTotal(){
   const rate=this.rates[Number(this.rate.value)];if(!rate)return;
   this.querySelector('[data-total]').textContent=this.text.total+': '+this.money(this.cart.total_price+Math.round(Number(rate.price)*100));
   const zip=this.zip.value.trim();const mainland=this.country.value==='Spain'&&/^\d{5}$/.test(zip)&&!['07','35','38','51','52'].includes(zip.slice(0,2));
   if(mainland&&/est[aá]ndar|standard/i.test(rate.name))this.renderDates();else this.querySelector('[data-dates]').textContent='';
  }
 }
 customElements.define('top-delivery',TopDelivery);
})();
